import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import EmpoweringYourStrategicGrowth from "./sections/EmpoweringYourStrategicGrowth";
import SustainableSourcing from "./sections/SustainableSourcing";
import TheMasterTeacherAdvantage from "./sections/TheMasterTeacherAdvantage";
import TailoredConnectivity from "./sections/TailoredConnectivity";
import WhatYourNeighborsSay from "./sections/WhatYourNeighborsSay";
import ReadyForTaxSeason from "./sections/ReadyForTaxSeason";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <EmpoweringYourStrategicGrowth />
      <SustainableSourcing />
      <TheMasterTeacherAdvantage />
      <TailoredConnectivity />
      <WhatYourNeighborsSay />
      <ReadyForTaxSeason />
      <Footer />
    </div>;
}